import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Button,
    Chip,
    List,
    ListItem,
    ListItemSecondaryAction,
    ListItemText,
    Typography
} from "@material-ui/core";
import Badge from "@material-ui/core/Badge";
import moment from "moment";
import { withStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEyeSlash } from "@fortawesome/pro-light-svg-icons";
import { updateMobileOfferForm, updateMobileView } from "../../actions/mobileActions";
import { updateDismissNotificationData, updateEmployeeDashboardData, updateLoading, updateSnackbar } from '../../actions'
import { SIDE_PANEL } from './constants'
import { GetExtraDetails } from "../Utils/dotNet";
import { handleAPIErrors } from "../../../auxilaries";
import * as Handlers from "../Utils/handlers"
import { DateFnsFormats, formatAs } from "../../../../common-client2/src/services/ukgDateTime";

const StyleListItemText = withStyles({
    root: {
        fontFamily: 'Roboto',
        maxWidth: 300,
    },
    primary: {
        fontSize: '12px',
    },
    secondary: {
        fontSize: '10px',
    },
})(ListItemText)
const StyleTypography = withStyles({
    body1: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontSize: '12px',
    }
})(Typography)
class NotificationPanel extends Component {
    constructor(props) {
        super(props);
    }

    getChipClass = (rowData, classes) => {
        switch (rowData.requestType) {
            case 0:
                return classes.chipTC;
            case 1:
                return classes.chipSS;
            case 2:
                return classes.chipOS;
            case 3:
                return classes.chipVTO;
            default:
                return classes.chipVTO;
        }
    }


    fetchExtraDetails = async (offerId, requestType) => {
        const { options, updateLoading, updateSnackbar } = this.props;
        var extraDetails = undefined;

        updateLoading(true);
        await GetExtraDetails(options, offerId, requestType).then(async response => {
            extraDetails = response.data;
            updateLoading(false);
        }).catch(err => {
            let message = handleAPIErrors(err.response)
            updateSnackbar({
                typeSnackbar: 'error',
                messageSnackbar: message,
                openSnackbar: true,
            })
            updateLoading(false);
        });

        return extraDetails;
    }

    handleViewButton = async (offerId, proposalId = null, isOwnOffer = false) => {
        const { storeData, managerSettings, updateMobileView, updateMobileOfferForm, closeDrawerAndExecute, updateLoading } = this.props;

        updateLoading(true)
        let privateOffer = storeData.privateOffers.find(x => x.offerId === offerId)
        let setting = managerSettings.find(x => x.id === privateOffer.managerSettingId)

        // Mark as viewed
        Handlers.markAsViewed.bind(this)(privateOffer.requestType, offerId, proposalId)

        // Build mobile form
        let raw = {
            ...privateOffer,
            source: (isOwnOffer) ? 0 : 1,
            offerorEmployeeId: privateOffer.employeeFromId,
            offerorEmployeeName: privateOffer.employeeFromName,
            offerorEmployeePrimaryJob: privateOffer.employeeFromPrimaryJob,
        }

        var history;
        if (setting.type !== 3) {
            let extraData = await this.fetchExtraDetails(raw.offerId, setting.type);
            history = extraData.history
        }

        // Change the view
        updateMobileOfferForm({
            shifts: raw.shifts,
            managerSetting: setting,
            partialDates: {
                isPartial: raw.isPartial,
                startDate: moment.utc(raw.partialFromDate),
                endDate: moment.utc(raw.partialToDate)
            },
            isPrivate: true,
            isProposedByOfferer: raw.isProposedByOfferer,
            source: (isOwnOffer) ? 0 : 1,
            status: raw.status,
            isOwnOffer: isOwnOffer,
            type: raw.requestType,
            id: 0,
            offerId: raw.offerId,
            history: history,
            proposals: raw.proposals,
            isValid: raw.isValid,
            rawValidationDetails: raw.rawValidationDetails,
            statusValidationDetails: raw.statusValidationDetails,
            raw: raw
        })
        closeDrawerAndExecute('right')
        updateMobileView(SIDE_PANEL)
        updateLoading(false)
    };

    handleDismissClick = (offerId, proposalId, isVTO) => {
        const { updateDismissNotificationData } = this.props;

        updateDismissNotificationData({
                offerId,
                proposalId,
                isVTO,
                open: true,
        });
    };

    render() {
        const { parsedNotifList, managerSettingNames, storeData, handleLoadMoreNotifications = () => { }, classes } = this.props;

        const renderListItemContent = (ele) => {
            if (ele.requestType !== 3) {
                return <StyleListItemText primary={
                    <StyleTypography>
                        <div >
                            {ele.isNew === true || ele.isNew > 0 ?
                                <Badge overlap="rectangular" style={{ margin: '10px' }} classes={{ badge: classes.badgeColor }} badgeContent={ele.isNew === true ? 1 : ele.isNew}></Badge>
                                : null}
                            <Chip size="small" style={{ margin: '5px' }} className={this.getChipClass(ele, classes)} label={managerSettingNames[ele.managerSettingId]}></Chip>
                        </div>
                        <span style={{ fontWeight: 'bold' }}>{ele.employeeName} </span>
                        <span>{ele.statusDisplay} </span>
                        <span style={{ textDecoration: 'underline' }}> {managerSettingNames[ele.managerSettingId]}</span>
                        <div style={{ fontSize: '13px' }}> {ele.shiftsDates}</div>
                    </StyleTypography>
                } secondary={`${"Submitted on "} ${formatAs(ele.notificationDate, DateFnsFormats.VERBOSE_LONG_DATETIME_FORMAT)}`} />
            } else {
                return <StyleListItemText primary={
                    <StyleTypography>
                        <div >
                            <Chip size="small" style={{ margin: '5px' }} className={this.getChipClass(ele, classes)} label={managerSettingNames[ele.managerSettingId]}></Chip>
                        </div>
                        <span>New VTO Signup </span>
                        <span style={{ textDecoration: 'underline' }}> {managerSettingNames[ele.managerSettingId]}</span>
                        <div style={{ fontSize: '13px' }}> {`Request period: ${ele.shiftsDates}`}</div>
                    </StyleTypography>
                } secondary={`Submission period: ${ele.notificationDate}`} />
            }
        }
        let privateOffersSummary = storeData.privateOffersSummary;
        return (
            <React.Fragment>

                    <List style={{ overflow: 'auto' }}>
                        {parsedNotifList.map((ele) => {
                            return (
                                <ListItem key={ele.offerId} button dense={true} divider onClick={() => this.handleViewButton(ele.offerId, ele.proposalId, ele.isOwnOffer)}>
                                    {renderListItemContent(ele)}
                                    <ListItemSecondaryAction >
                                        <Button
                                            size="small"
                                            onClick={(e) => {
                                                e.stopPropagation(); // Prevent triggering the ListItem onClick
                                                this.handleDismissClick(ele.offerId, ele.proposalId, (+ele.requestType) === 3);
                                            }}
                                            className={clsx(classes.buttonEllipsis)}
                                        >
                                            <FontAwesomeIcon icon={faEyeSlash} />
                                        </Button>
                                    </ListItemSecondaryAction>
                                </ListItem>
                            )
                        })}
                        {
                            privateOffersSummary && privateOffersSummary.offerIds.length !== privateOffersSummary.loadedIds.length ?
                                <ListItem dense={true} style={{ width: '100%', padding: '25px 0px', justifyContent: 'center' }} onClick={() => handleLoadMoreNotifications()}>
                                    <StyleTypography>
                                        <div style={{ fontSize: '14px' }}>LOAD MORE</div>
                                    </StyleTypography>
                                </ListItem>
                                :
                                null
                        }
                    </List>

            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        managerSettingNames: state.managerSettingNames,
        person: state.person,
        statusDictionary: state.statusDictionary,
        storeData: state.data,
        managerSettings: state.managerSettings,
        options: state.httpOptions,
        dateRanges: state.dateRanges,
        dismissNotificationData: state.dismissNotificationData,
    };
};

const mapDispatchToProps = {
    updateLoading,
    updateMobileOfferForm,
    updateMobileView,
    updateSnackbar,
    updateEmployeeDashboardData,
    updateDismissNotificationData
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationPanel);